import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";

import { departmentSelectOptionRequest } from "../../api/department";
import { createFormRequest, editFormRequest } from "../../api/form";
import { EmployeeAsyncSelect } from "components/EmployeeAsyncSelect/EmployeeAsyncSelect";

class OTForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            resource: {
                employee: null,
                department: null,
                hoursRequested: null,
                reason: null,
                approvedBy: null,
            },
            employeeSelectOptions: [],
            departmentSelectOptions: [],
            formErrors: null,
        };
    }

    componentDidMount() {
        // employeeSelectOptionRequest(
        //     (result) => this.setState({ employeeSelectOptions: result }),
        //     (error) => this.setState({ error: "There was an error" }),
        // );
        departmentSelectOptionRequest(
            (result) => this.setState({ departmentSelectOptions: result }),
            (error) => this.setState({ error: "There was an error" }),
        );
    }

    handleFormChange = (e) => {
        const { target } = e;
        const { name, value } = target;

        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                [name]: value,
            },
        }));
    };

    errorMessage = (name, message) => {
        const { formErrors } = this.state;
        return (
            <>
                {formErrors && formErrors[name] && (
                    <div className="form-text text-danger sz-11px">
                        {message}
                    </div>
                )}
            </>
        );
    };

    validate = () => {
        const { employee, hoursRequested, approvedBy } = this.state.resource;

        const errors = {};
        if (!employee) {
            errors.employee = true;
        }

        if (!hoursRequested) {
            errors.hoursRequested = true;
        }

        if (!approvedBy) {
            errors.approvedBy = true;
        }

        if (Object.keys(errors).length > 0) {
            this.setState({ formErrors: errors });
        } else {
            this.setState({ formErrors: null });
            this.save();
        }
    };

    save = () => {
        const { employee, department, hoursRequested, reason, approvedBy } =
            this.state.resource;

        const { instanceId } = this.props;

        const isNewRecord = !instanceId;

        let data = {
            employee,
            formType: "ot-request",
            department,
            hoursRequested,
            reason,
            approvedBy,
        };

        if (isNewRecord) {
            createFormRequest(
                data,
                (result) => this.saveSuccess(),
                (error) => this.saveFailure(),
            );
        } else {
            editFormRequest(
                instanceId,
                data,
                (result) => this.saveSuccess(),
                (error) => this.saveFailure(),
            );
        }
    };

    saveSuccess = () => {
        const { employee } = this.state.resource;

        this.setState({ error: null });
        this.props.goToList(employee);
    };

    saveFailure = () => {
        this.setState({ error: "There was an error saving tag." });
    };

    handleChange = (employeeValue) => {
        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                employee: employeeValue.value,
            },
        }));
    };

    handleApproveChange = (approveValue) => {
        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                approvedBy: approveValue.value,
            },
        }));
    };

    render() {
        const { department, hoursRequested, reason } =
            this.state.resource;

        const { departmentSelectOptions } = this.state;

        return (
            <Row>
                <Col md={12}>
                    <Card
                        title="OT Request Form"
                        content={
                            <form>
                                <FormGroup>
                                    <ControlLabel>
                                        Employee
                                        <span className="required-star">*</span>
                                    </ControlLabel>
                                    <EmployeeAsyncSelect
                                        onChange={this.handleChange}
                                    />
                                    {/* <FormControl 
                        onChange={this.handleFormChange}
                        componentClass="select" 
                        name="employee"
                        value={employee}
                      >
                      <option value="">Select</option>
                      {employeeSelectOptions.map(option => {
                          return (
                            <option
                              key={option.value}
                              value={option.value}
                            >
                              {option.label}
                            </option>
                          );
                      })}
                    </FormControl> */}
                                    {this.errorMessage(
                                        "employee",
                                        "Employee can't be empty",
                                    )}
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Department</ControlLabel>
                                    <FormControl
                                        onChange={this.handleFormChange}
                                        componentClass="select"
                                        name="department"
                                        value={department}
                                    >
                                        <option value="">Select</option>
                                        {departmentSelectOptions.map(
                                            (option) => {
                                                return (
                                                    <option
                                                        key={option.value}
                                                        value={option.value}
                                                    >
                                                        {option.label}
                                                    </option>
                                                );
                                            },
                                        )}
                                    </FormControl>
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>
                                        Hours Requested
                                        <span className="required-star">*</span>
                                    </ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="hoursRequested"
                                        value={hoursRequested}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                    {this.errorMessage(
                                        "hoursRequested",
                                        "Hours Requested can't be empty",
                                    )}
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Reason</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="reason"
                                        value={reason}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>
                                        Approved By
                                        <span className="required-star">*</span>
                                    </ControlLabel>
                                    <EmployeeAsyncSelect
                                        onChange={this.handleApproveChange}
                                        placeholder={"Approved By"}
                                    />
                                    {/* <FormControl
                                        onChange={this.handleFormChange}
                                        componentClass="select"
                                        name="approvedBy"
                                        value={approvedBy}
                                    >
                                        <option value="">Select</option>
                                        {employeeSelectOptions.map((option) => {
                                            return (
                                                <option
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </option>
                                            );
                                        })}
                                    </FormControl> */}
                                    {this.errorMessage(
                                        "approvedBy",
                                        "Approved By can't be empty",
                                    )}
                                </FormGroup>

                                <Button
                                    bsStyle="primary"
                                    pullRight
                                    fill
                                    onClick={this.validate}
                                >
                                    Submit Form
                                </Button>
                                <div className="clearfix" />
                            </form>
                        }
                    />
                </Col>
            </Row>
        );
    }
}

export default OTForm;
